export const submitRequest = `
    mutation SubmitRequest($input: SubmitRequestInput!) {
        submitRequest(input: $input) {
            requestCount
            failedRequestCount

        }
    }
`;